import React from 'react';
import { InfiniteData, useMutation, useQueryClient } from 'react-query';

import { TopicComment } from './interfaces';
import {
  retryCommentMedia,
  RetryCommentMediaInput,
} from './services/retryCommentMedia';
import { discussionTopicCommentsKey } from './useFeedbackCommentsQuery';

export function useRetryCommentMedia(topicId: string) {
  const queryClient = useQueryClient();
  const mutation = useMutation((input: RetryCommentMediaInput) =>
    retryCommentMedia(input),
  );

  const mutateAsync = React.useCallback(
    async (input: RetryCommentMediaInput) => {
      const newMedia = await mutation.mutateAsync(input);

      queryClient.setQueryData<InfiniteData<TopicComment[]>>(
        [discussionTopicCommentsKey, topicId],
        (old = { pages: [], pageParams: [] }) => ({
          ...old,
          pages: old.pages.map((page) =>
            page.map((comment) =>
              comment.id !== input.commentId
                ? comment
                : {
                    ...comment,
                    medias: [...(comment.medias ?? []), newMedia],
                  },
            ),
          ),
        }),
      );

      return newMedia;
    },
    [mutation, queryClient, topicId],
  );

  return { ...mutation, mutateAsync };
}
